import { makeAutoObservable } from "mobx";
import services from "../services";
import { extractErrorMessage } from "../utils/helpers";
import { generateLoadEntity } from "../utils/mobx";

class UserSearchStore {
  userSearchLoading = null;
  userSearchInfo = null;

  constructor() {
    makeAutoObservable(this);
  }

  setError(error, type = "userSearchError") {
    error = extractErrorMessage(error);
    this.error = error;
  }

  searchDownlineCustomer = generateLoadEntity(
    "userSearchInfo",
    this,
    "userSearchLoading",
    (params) => {
      return services.UserSearchService.list(params);
    },
    "userSearchInfo"
  );
}

export default UserSearchStore;
